import React from 'react'

function DuplicateGroup(props) {
  const { disabled, onClick, style, ...rest } = props
  return (
    <svg
      width="58"
      height="57"
      viewBox="0 0 58 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : undefined,
        opacity: disabled ? 0.5 : 1,
        ...(style || {}),
      }}
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      <g filter="url(#filter0_d_496_9204)">
        <rect x="2" y="1" width="54" height="53" fill="#FBFAFF" />
        <rect x="2.5" y="1.5" width="53" height="52" stroke="#E3DEFF" />
        <path
          d="M20 24.5V34.9C20 35.4601 20 35.7399 20.109 35.9538C20.2049 36.142 20.3577 36.2952 20.5459 36.3911C20.7596 36.5 21.0395 36.5 21.5985 36.5H32.0001M24 29.3002V21.7002C24 20.5801 24 20.0196 24.218 19.5918C24.4097 19.2155 24.7155 18.9097 25.0918 18.718C25.5196 18.5 26.0801 18.5 27.2002 18.5H34.8002C35.9203 18.5 36.4801 18.5 36.9079 18.718C37.2842 18.9097 37.5905 19.2155 37.7822 19.5918C38.0002 20.0196 38.0002 20.5797 38.0002 21.6998L38.0002 29.2998C38.0002 30.4199 38.0002 30.98 37.7822 31.4078C37.5905 31.7841 37.2842 32.0905 36.9079 32.2822C36.4805 32.5 35.9215 32.5 34.8036 32.5H27.1969C26.079 32.5 25.5192 32.5 25.0918 32.2822C24.7155 32.0905 24.4097 31.7842 24.218 31.4079C24 30.9801 24 30.4203 24 29.3002Z"
          stroke="#3249D7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_496_9204"
          x="0"
          y="0"
          width="58"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_496_9204"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_496_9204"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default DuplicateGroup
